// Core
import React, { useState } from "react";

// Contrib
import { ButtonGroup, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Custom
import Searchbar from "./searchbar";
import AlphaHeader from "./alphaheader";

function Home(props) {
   const data = props.data;
   const [view, setView] = useState("cards");

   return (
      <>
         <div className="greenHeader home headerBg">
            <h1>{data.name}</h1>
            <h2>
               <strong>FAQs</strong>
            </h2>
            <Searchbar />
            <div style={{ textAlign: "right" }}>
               <ButtonGroup className={"viewStyle " + view}>
                  <Button onClick={() => setView("cards")}>
                     <FontAwesomeIcon icon="border-all" />
                  </Button>
                  <Button onClick={() => setView("list")}>
                     <FontAwesomeIcon icon="list" />
                  </Button>
               </ButtonGroup>
            </div>
         </div>
         <div style={{ padding: "40px 100px" }}>
            <div className={"itemsView " + view} style={{ marginTop: "-200px" }}>
               {data.data.map((item) => (
                  <AlphaHeader data={item} key={item.ID} />
               ))}
            </div>
         </div>
      </>
   );
}

export default Home;
